import { classNames } from 'utils/classNameUtils';

const lineBreaksBetweenHtmlNodesMatchesCache = {};
const lineBreaksBetweenHtmlNodesRegex = />(\s+)</g;

// @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
function getLineBreaksMatch({ messageContent, uid }) {
  // @ts-expect-error TS7053 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  if (lineBreaksBetweenHtmlNodesMatchesCache[uid] !== undefined) {
    // @ts-expect-error TS7053 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    return lineBreaksBetweenHtmlNodesMatchesCache[uid];
  }

  const match = lineBreaksBetweenHtmlNodesRegex.test(messageContent);

  // @ts-expect-error TS7053 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  lineBreaksBetweenHtmlNodesMatchesCache[uid] = match;

  return match;
}

// such dynamic class name generation based on a message content is required as messages from channels (e.g. Airbnb)
// require `white-space: pre-wrap;` in order to display line breaks properly, whereas messages created with PMP templates
// must not have that CSS property as they may contain line breaks between HTML nodes that must be collapsed
export function getInboxMessageContentClassName(params: {
  messageContent: string;
  uid: string;
}) {
  const hasLineBreaks = getLineBreaksMatch(params);

  return classNames({
    'collapse-line-breaks': hasLineBreaks,
  });
}

export function cleanUpMessageContentClassNamesCache() {
  // just in order to avoid memory leaks when not reloading the page for a long time
  if (Object.keys(lineBreaksBetweenHtmlNodesMatchesCache).length > 2000) {
    Object.keys(lineBreaksBetweenHtmlNodesMatchesCache).forEach((key) => {
      // @ts-expect-error TS7053 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      delete lineBreaksBetweenHtmlNodesMatchesCache[key];
    });
  }
}
